/* src/app/home-new/tooltip-info-components/tooltip-info-binding/tooltip-info-binding.component.scss */
img {
  max-width: 50px;
}
ul {
  padding-left: 20px;
}
/*# sourceMappingURL=tooltip-info-binding.component-QBOX2PUF.css.map */
